<template>

    <div v-show="showNotice" :class="classes" :style="'background-color:'+color">

        <div class="container">

            <v-row dense>
                <v-col cols="11" class="flex-shrink-1 align-self-center">

                    <!-- EDIT MODE -->
                    <text-editor v-if="editMode"
                                 v-model="cookieNoticeModel"
                                 hint="Cookie notice"
                                 :show-under="true"
                    >

                        <div :class="fontClass"
                             v-html="cookieNoticeHtml ? cookieNoticeHtml : ''"></div>
                    </text-editor>

                    <!-- NON EDIT MODE -->
                    <div v-if="!editMode" :class="fontClass" v-html="cookieNoticeHtml ? cookieNoticeHtml : ''"></div>

                </v-col>

                <!-- CLOSE BUTTON -->
                <v-col cols="1" class="flex-grow-1 align-self-center">
                    <v-btn fab small :color="lighten(lighten(color))" elevation="0" @click="cookiePolicyAccepted">
                        <v-icon medium :class="buttonTextClass">mdi-close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </div>

</template>

<script>

    import TextEditor from "../TextEditor";
    import policyLinkHelperMixin from "../../mixins/policyLinkHelperMixin";
    import colorMixin from "../DynamicProflingQuestions/colorMixin";

    export default {

        mixins: [policyLinkHelperMixin,colorMixin],

        components: {
            TextEditor
        },

        props: {
            color: {
                required: true,
                type: String,
                default: '#757575'
            },
            editMode: {
                required: true,
                type: Boolean
            },
            editContentOnly: {
                required: false,
                type: Boolean,
                default: false,
            },
            subPanelId: {
                type: Number,
                required: true,
            },
            locale: {
                type: Object,
                required: true,
            },
            cookieNotice: {
                type: String | null,
                required: true,
            },
        },

        data() {
            return {
                showNotice: true,
                data: {
                    cookieNotice: null,
                }
            }
        },

        computed: {

            cookieNoticeModel: {
                get() {
                    return this.data.cookieNotice;
                },
                set(value) {
                    this.data.cookieNotice = value;
                    this.$emit('change:translations', this.data);
                }
            },

            fontClass() {
                return 'body-2 ' + this.getFontClasses(this.color);
            },

            buttonTextClass() {
                return this.getFontClasses(this.color);
            },

            classes() {
                let classes = ['cookiePolicy text-center'];
                classes.push(this.editMode || this.editContentOnly ? 'cookiePolicyAbsolute' : 'cookiePolicyFixed');
                return classes;
            },

            cookieNoticeHtml() {
                if (this.cookieNotice) {
                    return this.replaceVariables(
                        this.data.cookieNotice,
                        this.getFontClasses(this.color),
                        this.subPanelId,
                        this.locale.code
                    );
                }
                return '';
            },
        },

        mounted() {
            if (document.cookie.indexOf('CookiePolicyAccepted=true') === -1 || this.editMode) {
                this.showNotice = true;
            } else {
                this.showNotice = false;
            }

            this.data.cookieNotice = this.cookieNotice;
        },

        methods: {
            cookiePolicyAccepted() {
                this.showNotice = false;

                let d = new Date();
                d.setTime(d.getTime() + 1000 * 60 * 60 * 24 * 356);
                const expires = d.toUTCString();

                document.cookie = "CookiePolicyAccepted=true; expires= " + expires + " ; path=/ ; secure";
            }
        }
    }
</script>

<style scoped>

    .cookiePolicy {
        width: 100%;
        opacity: 0.9;
        bottom: 0px;
        left: 0px;
        z-index: 4;
    }

    .cookiePolicyAbsolute {
        position: absolute;
    }

    .cookiePolicyFixed {
        position: fixed;
    }
</style>
